<template>
  <div class="flex items-center">
    <div class="project-company-avatar flex">
      <div class="project-company-avatar-container">
                        <span
                            v-if="!photoUrl"
                        >{{(company) | getFirstLetter}}</span>
        <img v-else :src="photoUrl" alt />
      </div>
    </div>
    <div class="flex-1">
      {{company}}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      photoUrl: null,
      company: null
    };
  },
  beforeMount() {
    this.photoUrl = this.params.data.photoUrl;
    this.company = this.params.data.companyName;
  }

};
</script>
